import Cookies from 'universal-cookie';

const cookies = new Cookies();

const ROS_PREVIEW_SESSION = 'ROS_PREVIEW_SESSION';

export const getRosPreviewSession = () => cookies.get(ROS_PREVIEW_SESSION);

const defaultCookieAttributes = {
  path: '/',
  domain: process.env.NEXT_PUBLIC_BASE_DOMAIN,
  sameSite: 'none',
  secure: true
};

export const setRosPreviewSession = (value = 'userId:templateId', attributes = defaultCookieAttributes) => {
  const cookieValue = `${value}:${process.env.NEXT_PUBLIC_APP_ENV}`;
  cookies.set(ROS_PREVIEW_SESSION, cookieValue, attributes);
};
